var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78709 6.69822C8.78709 5.76084 9.19846 5.21965 9.89812 5.21965C10.473 5.21965 10.8583 5.61585 10.8987 6.15366H11.8656V6.06093C11.8209 5.06033 11.0024 4.375 9.89138 4.375C8.53926 4.375 7.76879 5.26012 7.76879 6.694V7.3237C7.76879 8.75674 8.53167 9.625 9.89138 9.625C10.999 9.625 11.8176 8.95737 11.8656 7.99049V7.89439H10.8987C10.8583 8.41281 10.4798 8.7795 9.89812 8.7795C9.19087 8.7795 8.78709 8.25686 8.78709 7.3237V6.69822ZM3.82117 9.52806L4.681 6.00108H4.71893L5.57876 9.52806H6.42678L7.65077 4.4711H6.65438L5.96315 8.14222H5.91594L5.09658 4.4711H4.30419L3.48483 8.14222H3.44015L2.74302 4.4711H1.75L2.97399 9.52806H3.82117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWc);
export default __webpack_public_path__ + "static/media/icon-WC.1c5aa330aecabfb7ef8b8525115af221.svg";
export { ForwardRef as ReactComponent };